import { useParams } from "react-router-dom"
import "./index.less";
import { CommonTabbarContext, SystemContext, TabContext } from "@/App";
import { useContext, useEffect, useState } from "react";
import { CommonTabbarState, TabRoute } from "@/global/components/common-tabbar";
import { Skeleton } from "antd";
import { SystemStatus } from "@/global/store/system-store";
import { GlobalCable } from "@/global/interface/lib-device/global-cable";
import { getGlobalCableDetail } from "@/api/lib/lib-cable";

interface IProps {
    cableId: number
    needRender: boolean
}

export default function LibCablePanel(props: IProps) {
    const [globalCable, setGlobalCable] = useState<GlobalCable>(null); // 传感器
    const [loading, setLoading] = useState<boolean>(false); // loading

    // 初始化
    useEffect(() => {
        if (!props?.cableId) return;
        setLoading(true)

        getGlobalCableDetail(+props?.cableId).then(res => {
            let data: GlobalCable = res.data || null;
            setGlobalCable(data);
        }).finally(() => {
            setLoading(false);
        })
    }, [props?.cableId, props?.needRender])

    return (
        <div className="lib-cable-container">
            <Skeleton loading={loading}>
                <div className="title">
                    {'数据线缆'}
                </div>
                <div className="main">

                    <div className="item">
                        <div className="item-name">型号</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.marking || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">厂商</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.manufacturer || ''}
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-name">规格</div>
                        <div className="item-value-list">
                            <div className="value-item">
                                {globalCable?.specification || ''}
                            </div>
                        </div>
                    </div>
                </div>
            </Skeleton>
        </div>
    )
}